export const SIGNIN = '/users/signin'
export const GET_COMPANIES= '/s-user/super/companies/get'
export const EDIT_COMPANY_SUB = '/s-user/super/company/update'
export const SESSIONOUT = '/users/sessionout';